<script>
import { Cell, Switch } from 'vant'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
    name: 'text-switcher',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell': Cell,
        'van-switch': Switch,
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
    props: {
        label: String,
        indicated: Boolean,
        checked: Boolean,
        disabled: Boolean,
        readonly: Boolean,
        separated: {
            type: Boolean,
            default: true
        },
        hidden: Boolean,
	},

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['change-data', 'click-indication'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            opened: null
        }
    },

    watch: {
        checked(value) {
             console.log('watch checked', value)
            this.opened = value
        }
    },
    
    mounted() {
         console.log('mounted', this.checked)
        this.opened = this.checked
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onSwitcherChange(data) {
            console.log('onSwitcherChange', data)
            if (!this.disabled && !this.readonly) {
                this.$emit('change-data', data)
            }
        },
        onIndicationClick() {
            console.log('onIndicationClick')
            this.$emit('click-indication')
        }
    },
}
</script>

<template>
    <!-- component -->
    <div 
        class="text-switcher no-padding" 
        :class="{ 'van-cell': separated }"
    >
        <van-cell 
            :class="{ disabled: disabled }"
            center
        >
            <template #title>
                <span class="r-outer-margin">{{ label }}</span>
                <van-icon v-if="indicated" name="info-o" @click="onIndicationClick"/>
            </template>
            <template #default>
                <van-switch 
                    v-if="!hidden"
                    v-model="opened" 
                    :disabled="disabled || readonly"
                    size="20px"
                    @change="onSwitcherChange"
                />
            </template>
        </van-cell>
    </div>
</template>